import { Box, Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import type { OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { CreativeThumbnail, Text } from '@feathr/components';

import type { IAdDimensionOption } from './AdDimensionsSelect.types';

function AdDimensionOption(props: OptionProps<IAdDimensionOption>): JSX.Element {
  const { data } = props;
  const theme = useMantineTheme();

  return (
    <components.Option {...props}>
      <Flex align={'center'} gap={theme.spacing['3']}>
        <CreativeThumbnail
          height={data.height}
          variant={data.isMeta ? 'meta' : 'display'}
          width={data.width}
        />
        <Text.DefaultMedium>{data.name}</Text.DefaultMedium>
        <Box ml={'auto'}>
          <Text.SmallRegular>
            {data.width}x{data.height} · {data.aspectRatio}
          </Text.SmallRegular>
        </Box>
      </Flex>
    </components.Option>
  );
}

export default AdDimensionOption;
